import { createSelector } from 'reselect';
import { RootState } from '../../../../types';
import { EntityTypes } from '../../../../constants/entities';
import { IActionFeed, IActionFeedItem, selectActionFeed } from './actionFeed';

const id = (state: RootState, id?: number) => id || state.state[EntityTypes.ACTION];
const feed = selectActionFeed;

export const selectFeedNext = createSelector([id, feed], (id: number, feed: IActionFeed) => {
  return feed.feed[feed.index + 1] as IActionFeedItem;
});
